import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = { style: {"margin-bottom":"4%"} }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "flex justify-between mt-2" }

import { storeToRefs } from 'pinia'
import { patientStore } from '@/store/patient'
import { Modal } from "flowbite-vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfModal',
  props: {
  index: Number,
  table: String,
  idtype: String,
  idConf: String
},
  emits: ["closeModal", "refreshPage"],
  setup(__props, { emit }) {

const props = __props;

const store = patientStore();
const { patient } = storeToRefs(store)





function cancelConfidenzialita() {
  emit('closeModal');
}
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const showLoading = ref(false);

async function saveData() {
  patient.value[props.table][props.index].id_paziente = patient.value.id_paziente;
  const userInput = await alertModal.value?.openModal("Salvare le modifiche ? ", true);
  if (userInput) {
    showLoading.value = true;
    await store.savePaziente(props.table, patient.value[props.table][props.index][props.idtype])
      .then(() => {
        showLoading.value = false;
        emit('closeModal');
        alertModal.value?.openModal("Confidenzialita aggiornato con successo! ", false);
        if (props.table == 'diagnosi') {
          store.fetchDiagnosi();
        } else if (props.table.includes('esami')) {
          store.fetchEsami();
        } else if (props.table.includes('emergenza')) {
          store.fetchEmergencyContact();
        }})
           .catch((res) => {
            showLoading.value = false;
            emit('closeModal');
            alertModal.value?.openModal("Errore durante la modifica il confidenzialita " + res, false);
            store.fetchEmergencyContact();
          });
  }
}




return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Modal), {
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModal')))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Seleziona il livello di confidenzialita: ')), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("Livello di confidenzialità *")), 1),
        _withDirectives(_createElementVNode("select", {
          id: "confidenzialità",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(patient)[props.table][props.index][props.idConf]) = $event)),
          class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, (item, key) => {
            return (_openBlock(), _createElementBlock("option", {
              value: item.id_livello_confidenzialita,
              key: key
            }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_3))
          }), 128))
        ], 512), [
          [_vModelSelect, _unref(patient)[props.table][props.index][props.idConf]]
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: cancelConfidenzialita,
            type: "button",
            class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
          }, _toDisplayString(_ctx.$t('Annulla')), 1),
          _createElementVNode("button", {
            onClick: saveData,
            type: "button",
            class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          }, _toDisplayString(_ctx.$t('Salva')), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})